module.exports = __webpack_public_path__ + "static/5-38eed0470245f51fc498079076cdb9b0.jpg";